<template>
  <footer id="footer">
    <div class="footer">
      <div class="container">

        <!-- Footer Links -->
        <div class="row">
          <div class="col-12">
            <h4>Explore RM Software Services</h4>
          </div>

          <div class="col-12 col-sm-4">
            <ul>
              <li>
                <router-link :to="{ path: '/', hash: '#home' }" @click="scrollToSection('#home')">Home</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/', hash: '#about' }" @click="scrollToSection('#about')">About</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/', hash: '#services' }" @click="scrollToSection('#services')">Services</router-link>
              </li>
              <li>
                <a href="https://richardm90.github.io/docs/" target="_blank" rel="noopener">Docs</a>
              </li>
              <li>
                <router-link :to="{ path: '/', hash: '#contact' }" @click="scrollToSection('#contact')">Contact Us</router-link>
              </li>
            </ul>
          </div>

          <div class="col-12 col-sm-4">
            <ul>
              <li>
                <router-link :to="{ path: '/privacy' }">Privacy Policy</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/cookies' }">Cookie Policy</router-link>
              </li>
            </ul>
          </div>
        </div>

        <hr>

        <!-- Footer Credits -->
        <div class="row">
          <div class="col-6">
            <p>&copy; {{ currentYear }} RM Software Services Ltd</p>
          </div>
          <div class="col-6">
            <p class="text-end">
              <span>Website by <a href="http://www.richardmoulton.co.uk/" target="_blank" rel="noopener">Richard Moulton</a></span>
              &nbsp;&nbsp;
              <span>Designed by <a href="https://bootstrapmade.com/" target="_blank" rel="noopener">BootstrapMade</a></span>
            </p>
          </div>
        </div>

      </div>
    </div>

    <!-- Back to Top Button -->
    <a
      v-show="showBackToTop"
      href="#"
      class="back-to-top"
      @click.prevent="scrollToTop"
    >
      <font-awesome-icon icon="chevron-up" />
    </a>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      showBackToTop: false
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToSection(hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 100;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
